import { useUserData } from '@/services/user';
import { OnboardingExperiment } from '@common/experiments';

export const useIsOnboardingExperimentEnabled = (
    experiment: OnboardingExperiment
) => {
    const { userInfo } = useUserData();
    return userInfo?.experiments?.onboarding === experiment;
};
